import { Loader2 } from "lucide-react";

const EmptyFlashCard = ({ isPolling }: { isPolling: boolean }) => {
  return (
    <div className="h-[300px] md:h-[400px] w-full bg-white p-6 rounded-lg shadow-md grid place-items-center">
      <div className="flex flex-col items-center gap-4">
        {isPolling ? (
          <>
            <Loader2 className="h-8 w-8 animate-spin text-brand-primary" />
            <p className="text-muted-foreground">Generating questions...</p>
          </>
        ) : (
          <p className="text-muted-foreground">
            The Study Set has no questions.
          </p>
        )}
      </div>
    </div>
  );
};

export default EmptyFlashCard;
